exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-conditions[data-v-67aacc83]{width:1800px;height:280px;padding:20px;background:#f2f3f5}.select-conditions-row[data-v-67aacc83]{width:1000px;margin:20px 0}.clear-all[data-v-67aacc83]{margin-left:40px;font-size:14px}.inquiry-table[data-v-67aacc83]{margin-top:80px}.inquiry-pagination[data-v-67aacc83]{margin-top:40px;height:40px;text-align:right}\n", ""]);

// exports
